<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="8">
            <b-form-input v-model="queryParams.keyword" placeholder=""
                          v-on:keyup="$event.keyCode === 13 ? findReportSurvey() : ''"></b-form-input>
          </b-col>
          <b-col sm="2" style="text-align: center;">
            <b-button variant="primary" style="width: 100%;" v-on:click="findReportSurvey()">검색</b-button>
          </b-col>
        </b-row>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import _ from 'lodash'
import swal from 'sweetalert2'

import { EventBus } from "../../../event-bus";

export default {
  name: "reportSurveySearch",
  props: {
    fullDate: {
      type: Array,
    },
    queryParams: {
      keyword: {
        type: String,
      }
    },
  },
  methods: {
    // 리포트 서베이 검색
    findReportSurvey() {
      // console.log(this.queryParams, this.fullDate);
      EventBus.$emit('callFindReportSurvey');
    },
    // 리포트 서베이 목록
    findReportSurveyList() {
      // /api/select/extSiteList
      var token = sessionStorage.getItem("myToken");
      this.$http.get('/api/select/reportSurveyList?access_token='+token)
        .then((result) => {
          const { data } = result;
          this.siteList = data;
        })
    },
    
  },
}
</script>



// WEBPACK FOOTER //
// src/views/contents/reportSurvey/component/ReportSurveySearch.vue